import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import Delete from "@material-ui/icons/Delete";
import Schedule from "@material-ui/icons/Schedule";
import { Grid, Tooltip, IconButton } from "@material-ui/core";

import { withToggleModal } from "altus-ui-components";

import {
  getWorkScheduleDefinitions,
  initializeEditWorkScheduleForm,
  initializeCreateWorkScheduleForm,
  initializeSimpleCreateWorkScheduleForm,
  deleteEmployeeWorkSchedule,
} from "features/planner/employee/employee.actions";

import { formatDate } from "utils/format.util";
import { invokeIfFunction } from "utils/app.util";
import BasePage from "app/components/BasePage";
import { EMPTY_LIST, Format } from "app/app.constants";
import { getSummarizedDataStatesFromState } from "app/app.selectors";
import SortableList from "app/components/SortableList/SortableList";
import { ACTIONS } from "features/planner/employee/employee.constants";
import { getWorkSchedulesFromState } from "features/planner/employee/employee.selectors";
import EditWorkScheduleModal from "features/planner/employee/schedule/components/EditWorkScheduleModal";
import CreateWorkScheduleModal from "features/planner/employee/schedule/components/CreateWorkScheduleModal";
import SimpleWorkScheduleModal from "features/planner/employee/schedule/components/SimpleWorkScheduleModal";
import EmployeeWorkScheduleCalendar from "features/planner/employee/schedule/components/EmployeeWorkScheduleCalendar";

class EmployeeWorkScheduleContainer extends PureComponent {
  componentDidMount() {
    const { dispatchGetWorkScheduleDefinitions } = this.props;
    dispatchGetWorkScheduleDefinitions();
  }

  initializeCreateWorkSchedule = () => {
    const { employeeCardId, dispatchInitializeCreateWorkSchedule } = this.props;

    dispatchInitializeCreateWorkSchedule(employeeCardId);
  };

  initializeEditWorkSchedule = workSchedule => {
    const { employeeCardId, dispatchInitializeEditWorkSchedule } = this.props;

    dispatchInitializeEditWorkSchedule(employeeCardId, workSchedule);
  };

  columns = [
    {
      xs: true,
      title: "Name",
      getValue: item => item.get("workScheduleDefinitionName"),
    },
    {
      xs: true,
      title: "Shift Cycle",
      getValue: item =>
        item.get("workScheduleDefinitionCycleDayCount") > 0 &&
        item.get("workScheduleDefinitionShiftCycle"),
    },
    {
      xs: true,
      title: "Rotations",
      getValue: item => `${item.get("rotationTimes")}x`,
    },
    {
      xs: true,
      title: "Start Date",
      getValue: item => formatDate(item.get("startDate"), Format.date),
    },
    {
      xs: true,
      title: "End Date",
      getValue: item => formatDate(item.get("endDate"), Format.date),
    },
  ];

  actions = [
    {
      getValue: item => (
        <Tooltip title="Delete">
          <IconButton
            onClick={() =>
              this.props.dispatchDeleteWorkSchedule(
                this.props.employeeCardId,
                item.get("id"),
              )
            }
          >
            <Delete fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  getWorkScheduleKey = workSchedule => workSchedule.get("id");

  initializeCreateWorkSchedule = (startDate, endDate, callback) => {
    const { employeeCardId, dispatchInitializeCreateWorkSchedule } = this.props;

    dispatchInitializeCreateWorkSchedule(employeeCardId, startDate, endDate);
    invokeIfFunction(callback);
  };

  initializeSimpleCreateWorkSchedule = (startDate, endDate, callback) => {
    const {
      employeeCardId,
      dispatchInitializeCreateWorkSchedule,
      dispatchinItializeSimpleCreateWorkScheduleForm,
    } = this.props;

    if (startDate.isSame(endDate, "day")) {
      dispatchInitializeCreateWorkSchedule(employeeCardId, startDate);
    } else {
      dispatchinItializeSimpleCreateWorkScheduleForm(
        employeeCardId,
        startDate,
        endDate,
      );
    }

    invokeIfFunction(callback);
  };

  addButtonOnClick = () => {
    const { employeeCardId, dispatchInitializeCreateWorkSchedule } = this.props;

    dispatchInitializeCreateWorkSchedule(employeeCardId);
  };

  render() {
    const {
      Icon,
      breadcrumb,
      dataState,
      workSchedules,
      employeeCardId,
    } = this.props;

    return (
      <>
        <BasePage
          Icon={Icon}
          title={breadcrumb}
          displayAddButton
          displaySearchField={false}
          dataState={dataState}
          addButtonOnClick={this.addButtonOnClick}
        >
          <EmployeeWorkScheduleCalendar
            workSchedules={workSchedules}
            employeeCardId={employeeCardId}
            initializeCreateWorkSchedule={
              this.initializeSimpleCreateWorkSchedule
            }
          />
          <Grid container>
            <SortableList
              Icon={Schedule}
              dataState={dataState}
              items={workSchedules}
              columns={this.columns}
              actions={this.actions}
              defaultSortColumn={null}
              getKey={this.getWorkScheduleKey}
              noResultsMessage="No work schedules..."
              onRowClick={this.initializeEditWorkSchedule}
            />
          </Grid>
        </BasePage>
        <CreateWorkScheduleModal />
        <EditWorkScheduleModal />
        <SimpleWorkScheduleModal />
      </>
    );
  }
}

EmployeeWorkScheduleContainer.defaultProps = {
  workSchedules: EMPTY_LIST,
};

export default compose(
  connect(
    (state, { employeeCardId }) => ({
      workSchedules: getWorkSchedulesFromState(state, employeeCardId),
      dataState: getSummarizedDataStatesFromState(
        state,
        ACTIONS.QUERY_EMPLOYEE_WORK_SCHEDULES,
        ACTIONS.DELETE_EMPLOYEE_WORK_SCHEDULE,
      ),
    }),
    {
      dispatchDeleteWorkSchedule: deleteEmployeeWorkSchedule,
      dispatchGetWorkScheduleDefinitions: getWorkScheduleDefinitions,
      dispatchInitializeEditWorkSchedule: initializeEditWorkScheduleForm,
      dispatchInitializeCreateWorkSchedule: initializeCreateWorkScheduleForm,
      dispatchinItializeSimpleCreateWorkScheduleForm: initializeSimpleCreateWorkScheduleForm,
    },
  ),
  withToggleModal,
)(EmployeeWorkScheduleContainer);
